const HeaderFooterHeight = "84px";

export function colors() {
  return {
    __header: {
      headerBorder: "#c8c8c8",
    },
    headers: "#0064B4",
    __itsme: {
      default: "#ff4612",
      hover: "#e53f10",
    },
    __warning: {
      background: "rgba(255,243,205,0.8)",
      text: "#664d03",
    },
    __error: {
      background: "rgba(226, 225, 228,0.8)",
      text: "#000",
      icon: "#4a4b57",
      shadow: "rgba(175, 174, 177,0.8)",
    },
    __infoRandom: [
      {
        background: "rgba(255,243,205,0.8)",
        text: "#664d03",
        icon: "#332601",
        shadow: "rgba(204, 194, 164,0.8)",
      },
      {
        background: "rgba(216, 230, 255,0.8)",
        text: "#0c2146",
        icon: "#2264d1",
        shadow: "rgba(172, 184, 204,0.8)",
      },
      {
        background: "rgba(226, 225, 228,0.8)",
        text: "#000",
        icon: "#4a4b57",
        shadow: "rgba(175, 174, 177,0.8)",
      },
      {
        background: "rgba(220, 237, 221,0.8)",
        text: "#132c14",
        icon: "#37833b",
        shadow: "rgba(172, 186, 173,0.8)",
      },
    ],
    __attention: {
      warning: {
        background: "rgba(255, 246, 237)",
        text: "#463209",
        icon: "#b88217",
        borderColor: "#f5ce84",
      },
      error: {
        background: "rgba(255, 247, 250)",
        text: "#43130f",
        icon: "#c8372d",
        borderColor: "#faa9a3",
      },
      success: {
        background: "rgba(245, 250, 245)",
        text: "#132c14",
        icon: "#37833b",
        borderColor: "#a9d3ab",
      },
      info: {
        background: "rgba(34, 100, 209)",
        text: "#f5f8ff",
        icon: "#c4daff",
        borderColor: "rgba(34, 100, 209)",
      },
    },
    __content: {
      contentBackground: "#F9F9F9",
    },
    __footer: {
      footerBackground: "#243781",
    },
  };
}

export function fonts() {
  return { robotoSlab: "Roboto Slab" };
}

export function viewport() {
  return {
    height: `calc(100vh - (${HeaderFooterHeight} * 2) - 2px)`,
  };
}

export function zIndex() {
  return {
    background: "0",
    foreground: "1",
  };
}

export function header() {
  return {
    height: HeaderFooterHeight,
  };
}

export function footer() {
  return {
    height: HeaderFooterHeight,
  };
}

export function responsive() {
  return {
    __buttons: {
      width: { xs: "100%", sm: "250px", lg: "130px" },
      height: { xs: "50px", lg: "40px" },
      borderRadius: "100px",
    },
  };
}
